import { render, staticRenderFns } from "./ItemCreateModal.vue?vue&type=template&id=56f88a0a&scoped=true&"
import script from "./ItemCreateModal.vue?vue&type=script&lang=js&"
export * from "./ItemCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f88a0a",
  null
  
)

export default component.exports